var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-block mt-4 serial_card"},[(_vm.serial)?_c('SerialCard',{staticClass:"mt-3",attrs:{"serial":_vm.serial}}):(_vm.serialNotFound)?_c('h5',[_vm._v("Serial not found... :(")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }